module.exports = __webpack_public_path__ + "img/section2Location.035dd93b.png";